import React from 'react';
import Style from '../about/About.module.scss';
import ExpDetails from './ExpDetails';
import { Box,Grid } from '@mui/material';
import { info } from '../../assets/info/Info';

export default function Experience(){
    return (
      <>
      
       <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mt={'3rem'}>
    
       {info.experience.map((comp, index)=>(
         <Grid item xs={6} md={8} key={index}>
         
         <ExpDetails
           title={comp.title}
           location = {comp.location}
           company={comp.company}
           year={comp.year}
           description = {comp.description}
          //  description={comp.description.map((role,roleIndex)=>(
          //   <li key = {roleIndex}>{role}</li>
          //  ))
          // }
         />
       </Grid>
    

       ))}
       

        
       </Box>
      </>
    );
}